import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import {
  type FeatureFlagNamesEnum,
  type GetFeatureFlagsQuery,
} from "src/graphql/generated/types";
import { getActivatedFeatureFlags, notUndefined } from "src/utils";

import { useDisplayedAccountId } from "./useDisplayedAccountId";

/*
This hook should only be used when user is  authenticated
*/
export function useHasFeatureFlagActivated(
  feature: FeatureFlagNamesEnum,
): boolean {
  const queryClient = useQueryClient();
  // In an account's pages an agency-rolled flag follows that account; every
  // account counts anywhere else.
  const accountId = useDisplayedAccountId();

  const { featureFlags } = notUndefined(
    queryClient.getQueryData<GetFeatureFlagsQuery>(["getFeatureFlags"]),
  );

  const activatedFeatureFlags = useMemo(
    () => getActivatedFeatureFlags(featureFlags, { accountId }),
    [featureFlags, accountId],
  );

  return activatedFeatureFlags.has(feature);
}
